import { createMiddleware } from 'hono/factory'
import type { NexusEnv } from '../types.js'
import { createErrorResponse } from './error.middleware.js'

/**
 * Header name used to identify nexus-client requests.
 * Lightweight security layer for internal endpoints.
 */
export const NEXUS_CLIENT_HEADER = 'X-Nexus-Client'

/**
 * Requires the X-Nexus-Client header. Returns 404 (not 401/403) without it
 * to avoid revealing endpoint existence.
 */
export const requireNexusClient = createMiddleware<NexusEnv>(async (c, next) => {
  if (!c.req.header(NEXUS_CLIENT_HEADER)) {
    return c.json(createErrorResponse('NOT_FOUND', 'API endpoint not found'), 404)
  }
  await next()
})

/**
 * Creates a middleware that optionally requires the X-Nexus-Client header.
 */
export function createNexusClientMiddleware(required = true) {
  if (!required) {
    return createMiddleware<NexusEnv>(async (_c, next) => {
      await next()
    })
  }
  return requireNexusClient
}
